export const PageRoutes = {
  account: "/dashboard/account",
  addAddress: "/dashboard/account/add-address",
  addPayment: "/dashboard/account/add-payment",
  changePassword: "/dashboard/account/change-password",
  orders: "/dashboard/orders",
  signIn: "/sign-in",
  signUp: "/sign-up",
};
